import { render, staticRenderFns } from "./BizScopeDetail.vue?vue&type=template&id=a6e95606&scoped=true"
import script from "./BizScopeDetail.vue?vue&type=script&lang=js"
export * from "./BizScopeDetail.vue?vue&type=script&lang=js"
import style0 from "./BizScopeDetail.vue?vue&type=style&index=0&id=a6e95606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e95606",
  null
  
)

export default component.exports